import ApolloClientProvider from './ApolloClientProvider';

export default ApolloClientProvider;
